var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12664_19019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1277 27.0242L27.3619 13.8282L14.1659 0.593932L0.931678 13.7899L14.1277 27.0242Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12664_19019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1822 12.4824C14.9748 12.4698 14.777 12.5048 14.5984 12.5774C14.3837 12.6647 14.1495 12.5037 14.1499 12.272L14.1523 10.5499C14.1534 9.80471 13.5502 9.19977 12.8051 9.19869L11.083 9.1962C10.8513 9.19586 10.6909 8.96114 10.7788 8.74674C10.852 8.56839 10.8875 8.37066 10.8755 8.16327C10.8372 7.50089 10.3039 6.96026 9.64203 6.91375C8.86382 6.85903 8.21495 7.47359 8.21381 8.24041C8.21358 8.4173 8.24787 8.58619 8.31029 8.74068C8.39759 8.95658 8.2388 9.19208 8.00591 9.19174L6.2838 9.18925C5.53863 9.18817 4.93369 9.79137 4.93261 10.5365L4.93015 12.2546C4.92979 12.4853 5.16213 12.6466 5.37628 12.561C5.55471 12.4898 5.75214 12.456 5.95884 12.4694C6.61863 12.5123 7.15433 13.0462 7.19887 13.7059C7.25144 14.4844 6.63498 15.1316 5.86811 15.1305C5.69421 15.1302 5.52817 15.0967 5.37599 15.0358C5.16044 14.9497 4.92602 15.1075 4.92568 15.3396L4.9232 17.0578C4.92209 17.8029 5.52529 18.4079 6.27046 18.409L7.98859 18.4114C8.21921 18.4118 8.38054 18.1795 8.29498 17.9653C8.22371 17.7869 8.18995 17.5895 8.20336 17.3828C8.24616 16.723 8.78015 16.1873 9.43983 16.1427C10.2183 16.0901 10.8656 16.7066 10.8644 17.4735C10.8642 17.6474 10.8306 17.8134 10.7698 17.9656C10.6837 18.1812 10.8414 18.4156 11.0735 18.4159L12.7917 18.4184C13.5369 18.4195 14.1418 17.8163 14.1429 17.0711L14.1454 15.349C14.1457 15.1161 14.3817 14.958 14.5973 15.0459C14.7516 15.1088 14.9204 15.1436 15.0973 15.1438C15.8642 15.145 16.4806 14.4978 16.4281 13.7195C16.3835 13.0575 15.8444 12.5226 15.1822 12.4824Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3379 18.428L20.2871 18.4265C20.0554 18.4262 19.8944 18.6604 19.9817 18.8751C20.0543 19.0536 20.0893 19.2515 20.0767 19.4588C20.0365 20.1211 19.5016 20.6602 18.8396 20.7048C18.0612 20.7572 17.4141 20.1408 17.4152 19.374C17.4155 19.1971 17.4503 19.0283 17.5132 18.874C17.6011 18.6583 17.443 18.4224 17.2101 18.4221L15.488 18.4196C14.7428 18.4185 14.1396 17.8135 14.1407 17.0684",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.154 10.5508C14.1551 9.80567 14.7601 9.20248 15.5052 9.20355L17.2234 9.20604C17.454 9.20637 17.6146 9.43918 17.5285 9.65311C17.4567 9.83131 17.4223 10.0286 17.4351 10.2353C17.4761 10.8953 18.0084 11.4325 18.668 11.479C19.4463 11.5338 20.0954 10.9192 20.0965 10.1523C20.0967 9.97845 20.0636 9.81232 20.0033 9.65995C19.9177 9.44416 20.0762 9.21017 20.3083 9.21053L22.0265 9.21302C22.7716 9.21407 23.3748 9.81902 23.3737 10.5642L23.3713 12.2863C23.3709 12.5192 23.6064 12.678 23.8223 12.5907C23.9768 12.5282 24.1457 12.494 24.3226 12.4942C25.0894 12.4953 25.704 13.1442 25.6492 13.9224C25.6027 14.5843 25.0621 15.1176 24.3997 15.1559C24.1924 15.1679 23.9946 15.1324 23.8163 15.0592C23.6018 14.9713 23.3671 15.1316 23.3668 15.3634L23.3654 16.3785",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMatchIcon);
export default __webpack_public_path__ + "static/media/menu-match-icon.db638e09800c27fa365df79bca1da365.svg";
export { ForwardRef as ReactComponent };